import React from "react";
import "./FlipBook.css";

const FlipBook = () => {
  return (
    <div className="flipbook-container d-flex justify-content-center w-100 my-3">
      <iframe
        allowFullScreen={true}
        allow="autoplay; fullscreen; clipboard-write"
        scrolling="no"
        className="fp-iframe"
        src="https://heyzine.com/flip-book/534df389ad.html"
        style={{
          border: "1px solid lightgray",
          width: "100%",
          height: "600px",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
        }}
        title="Love Smarter, Not Harder Flipbook"
      />
    </div>
  );
};

export default FlipBook;
